import { scopeTypes } from './scopeNames'

export interface ConversionListParams {
  typeIds?: string
  statusIds?: string
  conversionIds?: string
  postbackPartnerIds?: string
  searchField?: string
  limit?: number
  sortBy?: string
}

export const getListFilterOptionsKey = {
  keys: (args: { scope: scopeTypes }) => [args],
}

export const getConversionListKey = {
  keys: (
    args: {
      scope: scopeTypes
    } & ConversionListParams
  ) => [args],
}

export interface ConversionsByIdsForCmpParams {
  conversionIds?: string
}

export const getConversionsByIdsForCmpKey = {
  keys: (
    args: {
      scope: scopeTypes
    } & ConversionsByIdsForCmpParams
  ) => [args],
}

export const getPixelCreationInfoQueryKey = getListFilterOptionsKey

export const getPostbackCreationInfoQueryKey = getListFilterOptionsKey

export const getConversionQueryKey = getListFilterOptionsKey

export const getConversionDetailsQueryKey = {
  keys: (scope: scopeTypes, conversionId: string) => [
    { scope, conversionId } as const,
  ],
}

export interface CampaignListParams {
  isGroup?: boolean
  conversionIds?: string
  searchField?: string
  limit?: number
  pageNo?: number
  sortBy?: string
}

export const getCampaignListKey = {
  keys: (args: { scope: scopeTypes } & CampaignListParams) => [args],
}

export const getCampaignsByConversionIdKey = {
  keys: (args: { scope: scopeTypes } & { conversionId: string }) => [args],
}

export const getCampaignBasicListKey = {
  keys: (
    args: { scope: scopeTypes } & { campaignIds: number[]; noOfEntries: number }
  ) => [args],
}

export interface GetSelectConversionsListForCmpParams {
  excludeConversionIds: string
  owId: number
  conversionTypeId: number
  searchField?: string
  limit?: number
  sortBy?: string
}

export const getSelectConversionsListForCmpKey = {
  keys: (
    args: { scope: scopeTypes } & GetSelectConversionsListForCmpParams
  ) => [args],
}
